let currency = { symbol: "R", code: "ZAR" };

export function setCurrency(c) {
  if (c?.currency_symbol) currency = { symbol: c.currency_symbol, code: c.currency_code };
}

export function money(n) {
  const v = Number(n || 0);
  return `${currency.symbol}${v.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

export function money2(n) {
  const v = Number(n || 0);
  return `${currency.symbol}${v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function num(n, d = 2) {
  return Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
}

// Fiscal month index (1-12) -> calendar month name, given fiscal start month
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function fiscalMonthLabel(fmIndex, startMonth = 1) {
  const calIndex = (startMonth - 1 + (fmIndex - 1)) % 12;
  return MONTHS[calIndex];
}

export const TIER_LABELS = {
  none: "No data",
  below_minimum: "Below minimum",
  below_threshold: "Below break-even",
  rehabilitation: "Rehabilitation",
  standard: "Standard",
  top: "Top tier",
  debtor_blocked: "Debtor blocked",
  ineligible: "Ineligible",
};

export const TIER_COLORS = {
  top: "bg-positive/15 text-positive border-positive/30",
  standard: "bg-brand/15 text-brand border-brand/30",
  rehabilitation: "bg-warning/15 text-warning border-warning/40",
  below_minimum: "bg-muted text-muted-foreground border-border",
  below_threshold: "bg-muted text-muted-foreground border-border",
  debtor_blocked: "bg-destructive/15 text-destructive border-destructive/30",
  ineligible: "bg-muted text-muted-foreground border-border",
  none: "bg-muted text-muted-foreground border-border",
};
